import { IPriceItem } from '@/interfaces';

/**
 * 格式化币种金额
 * @returns
 */
const formatCurrencyPrice = (prices: IPriceItem[], currency = 'CNY') => {
  const currencyPrice = prices?.find((item) => item?.currency === currency);

  if (currencyPrice) {
    return currencyPrice?.currency_symbol + currencyPrice?.price;
  }

  return undefined;
};

const formatRMBPriceAndCurrencyPrice = (prices: IPriceItem[], currency: string) => {
  if (prices?.length === 0) {
    return undefined;
  }

  return {
    rmbPrice: formatCurrencyPrice(prices, 'CNY'),
    currencyPrice: formatCurrencyPrice(prices, currency),
  };
};

export { formatCurrencyPrice, formatRMBPriceAndCurrencyPrice };
